import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ openModal }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner container">
        <a href="#hero" className="navbar-logo">
          <img
            src="https://embracebeautyclinic.com/assets/Embracelogo.png"
            alt="Embrace Beauty Clinic"
          />
        </a>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </button>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <li><a href="#about-us" onClick={() => setMenuOpen(false)}>About Us</a></li>
          <li><a href="#our-services" onClick={() => setMenuOpen(false)}>Services</a></li>
          <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
        </ul>

        <button className="btn-primary navbar-cta" onClick={openModal}>
          Make Appointment
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
